import chatImg from "../assets/img/chat.svg";
import logo from "../assets/img/trini-talk-bot-big.svg";
import { Link } from "react-router-dom";
import { UserIcon } from "../components/Icons";
import useAuth from "../hooks/useAuth";
import AlertMsg from "../components/info/AlertMsg";

function RecoverPassword() {
  document.title = "Restablecer Contraseña | Trini Talkbot.";

  const {
    tab,
    errorMsg,
    emailToRecovery,
    handleSubmitRecoveryPass,
    handleChangeRecoveryPass,
  } = useAuth();

  return (
    <>
      <div className="container">
        <div className="forms-container">
          <div className="signin-signup">
            <form onSubmit={handleSubmitRecoveryPass} className="sign-in-form">
              <div className="text-center">
                <h2 className="titleLogin">Restablecer Contraseña</h2>
                {tab === 1 ? (
                  <span style={{ color: "#ebebeb" }}>
                    Para poder restablecer tu contraseña, por favor ingresa tu
                    dirección de correo electrónico. Te enviaremos un enlace
                    para que puedas restablecer tu contraseña de manera segura.
                    ¡Estamos aquí para ayudarte a proteger y asegurar tu cuenta!
                  </span>
                ) : (
                  <span style={{ color: "#ebebeb" }}>
                    ¡Excelente! Hemos enviado un correo a tu dirección de correo
                    electrónico con las instrucciones que debes seguir. Por
                    favor, revisa tu bandeja de entrada y sigue los pasos
                    indicados para restablecer tu contraseña y acceder
                    nuevamente a tu cuenta. Si no encuentras el correo en tu
                    bandeja de entrada, asegúrate de revisar la carpeta de spam
                    o correo no deseado. Si necesitas alguna asistencia
                    adicional, escribenos a soporte@trinitalkbot.com.
                  </span>
                )}
              </div>
              <div className="mt-2">
                {errorMsg && <AlertMsg type="danger" text={errorMsg} />}
              </div>
              {tab === 1 && (
                <>
                  <div className="input-field">
                    <UserIcon color="#212529" />
                    <input
                      type="email"
                      placeholder="Ingresa tu correo electrónico.."
                      id="email"
                      name="email"
                      onChange={handleChangeRecoveryPass}
                      value={emailToRecovery}
                      required
                      maxLength={150}
                    />
                  </div>
                  <button type="submit" className="btnlogin solid">
                    Restablecer
                  </button>
                </>
              )}
            </form>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <img
                src={logo}
                alt="trini logo"
                className="imageLogo"
                onClick={() => {
                  location.href = "https://trinitalkbot.com/";
                }}
                style={{ cursor: "pointer" }}
              />
              <p className="loginSub">
                ¿Recordaste tu contraseña? Ingresa haciendo clic aquí.
              </p>
              <Link
                to="/login"
                id="sign-in-btn"
                className="btn btnlogin transparent"
                style={{ lineHeight: "2" }}
              >
                <span>Ingresar</span>
              </Link>
            </div>
            <img src={chatImg} className="image" alt="chatbot image" />
          </div>
        </div>
      </div>
    </>
  );
}

export default RecoverPassword;
